import { useState, KeyboardEvent } from "react";
import { X } from "lucide-react";
import { normalizeAlias } from "@/lib/docLinks";

export function LinkAliasesEditor({
  value,
  onChange,
}: {
  value: string[];
  onChange: (v: string[]) => void;
}) {
  const [draft, setDraft] = useState("");

  function commit(raw: string) {
    const n = normalizeAlias(raw);
    if (!n) return;
    if (value.includes(n)) return;
    onChange([...value, n]);
    setDraft("");
  }

  function onKey(e: KeyboardEvent<HTMLInputElement>) {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      commit(draft);
    } else if (e.key === "Backspace" && !draft && value.length) {
      onChange(value.slice(0, -1));
    }
  }

  return (
    <div className="flex flex-wrap gap-1.5 border rounded-md px-2 py-1.5 bg-background focus-within:ring-1 focus-within:ring-ring">
      {value.map((v) => (
        <span
          key={v}
          className="inline-flex items-center gap-1 rounded bg-muted px-2 py-0.5 text-xs"
        >
          {v}
          <button
            type="button"
            onClick={() => onChange(value.filter((x) => x !== v))}
            className="text-muted-foreground hover:text-foreground"
            aria-label={`Remove ${v}`}
          >
            <X className="h-3 w-3" />
          </button>
        </span>
      ))}
      <input
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={onKey}
        onBlur={() => draft && commit(draft)}
        placeholder={value.length ? "" : "Type an alias and press Enter"}
        className="flex-1 min-w-[160px] bg-transparent outline-none text-sm py-0.5"
      />
    </div>
  );
}
